import { Col } from 'antd';
import { useEffect } from 'react';
import styled from 'styled-components';
import {
  boxShadow, maxMobile, maxWidth, primaryHeadingColor, retina, secondaryFont, wMedium, white,
} from 'Utils/utilsStyle';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import {
  selectBuyersHighlights,
  selectBuyersHighlightsEnded,
  selectBuyersHighlightsLoading,
  selectBuyersHighlightsPageNumber,
} from 'Selector/BuyerGroupSelector';
import { BuyersHighlights } from 'Types/BuyerGroupsPageTypes';
import InfiniteScroll from 'react-infinite-scroll-component';
import { PeopleNotFound } from 'Pages/people/PeopleGroupDetail';
import classNames from 'classnames';
import { GROUP_DETAIL_ROUTE } from 'Utils/Constants';
import ArticleLoadingSkeletonBundle from 'Components/common/skeleton/ArticleLoadingSkeletonBundle';
import ArticleGridLayout from 'Components/common/components/ArticleGridLayout';
import PersonIntentData from './PersonIntentData';
import HeatMapProgress from '../../common/components/HeatMapProgress';

const Wrapper = styled.div`
  width: 100%;
  border-radius: 16px;

  .heading-group {
    font-family: ${secondaryFont};
    font-size: 28px;
    font-weight: ${wMedium};
    color: ${primaryHeadingColor};
    margin-bottom: 18px;

    @media all and (max-width: ${maxWidth}) , ${retina} {
     font-size: 22px;
    }
  }
  .tabs-details-container{
    margin-top: 30px;
  }


  .personDetailHighlightTabWrapper{
    padding: 24px 12px;
    box-shadow: ${boxShadow};
    background: ${white};
    border-radius: 16px;
    margin-bottom: 40px;

    @media all and (max-width: ${maxMobile}) {
      padding: 16px 0px;
      margin-bottom: 24px;
    }

    .articlesWrapper{

      .tagsAndArticleWrapper{
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
      }
    }

    .infiniteScrollWrapper,
    .heading-group{
      padding: 0 12px;

      @media all and (max-width: ${maxMobile}) {
        padding: 0px 10px;
      }
    }

    .heading-group{
      font-size: 18px;
      line-height: 15px;
      margin-bottom: 12px;
    }
  }
`;

type Props = {
  getHighlights: (num: number) => void
  flag: boolean
  listView: boolean
  groupName: string
};

const HighLightsTab = function HighLightsTab(props: Props) {
  const navigate = useNavigate();
  const {
    getHighlights, flag, listView, groupName,
  } = props;

  const [searchParams] = useSearchParams();
  const groupId = searchParams.get('groupId');
  const groupIdParsed = groupId ? parseInt(groupId, 10) : 0;
  const highlights: BuyersHighlights | null = useSelector(selectBuyersHighlights);
  const isLoading: boolean = useSelector(selectBuyersHighlightsLoading);
  const highlightsPageNumber: number = useSelector(selectBuyersHighlightsPageNumber);
  const highlightsEnded: boolean = useSelector(selectBuyersHighlightsEnded);

  const fetchMoreHighlights = () => {
    if (highlights && highlights?.articles.length && !isLoading) {
      getHighlights(highlightsPageNumber);
    }
  };

  useEffect(() => {
    if (highlights && !highlights?.articles.length && !isLoading && !flag) {
      navigate(`${GROUP_DETAIL_ROUTE}${groupIdParsed}`, { replace: true });
    }
  }, [isLoading]);

  return (
    <Wrapper>
      <div className="personDetailHighlightTabTagsWrapper">
        {highlights?.intentData && highlights.intentData.results.length > 0
          && (
            <Col
              span={12}
              xs={24}
              sm={24}
              md={12}
              className={classNames(' article-grid mb-c-20', { mbC10: listView })}
            >
              <PersonIntentData
                name={groupName}
                // keywords={highlights.intentData.results}
                loading={false}
                // intentAllowed={highlights.intentData.intentAllowed}
                // url={highlights.intentData.url}
                listview={false}
                showButtons={false}
              />
            </Col>
          )}
      </div>
      <div id="tabs-details" className="personDetailHighlightTabWrapper">
        <h3 className="heading-group">What is new in the group</h3>
        <HeatMapProgress pulse={[]} />
        <InfiniteScroll
          dataLength={highlights?.articles ? highlights.articles.length : 0}
          next={fetchMoreHighlights}
          hasMore={!highlightsEnded}
          loader={null}
          className="o-x-hidden infiniteScrollWrapper"
        >
          <div id="tabs-details" className="articlesWrapper">
            <ArticleGridLayout
              articlesArray={highlights?.articles}
              isLoading={isLoading}
            />

            {
              isLoading && <ArticleLoadingSkeletonBundle />
            }
          </div>
        </InfiniteScroll>
        {
          !isLoading && !highlights?.articles.length ? (
            <div className="d-flex justify-content-center align-items-center w-100" style={{ margin: '200px 0px' }}>
              <PeopleNotFound>No updates to show.</PeopleNotFound>
            </div>
          ) : null
        }
      </div>
    </Wrapper>
  );
};

export default HighLightsTab;
